// Copyright (c) 2017 Deere & Company

import {
    createErrorObject,
    errorAlertBar
} from '../../shared/services/alert-bar';
import {
    mapClaimValidation,
    mapSearchRoutes,
    mapValidationErrorMessages
} from '../shared/services/home-page-helper';
import actions from '../actions-list';
import {routerActions} from 'react-router-redux';
import {translate} from '../../shared/services/translation-service';

export const updateSearchQueryString = query => ({
    query,
    type: actions.UPDATE_HOME_PAGE_SEARCH_QUERY_STRING
});

export const updateSearchByDropDown = (key, list) =>
    dispatch => {

        if (list.length > 0) {

            dispatch({
                key,
                list,
                type: actions.UPDATE_HOME_PAGE_SEARCH_BY
            });

        }

    };

export const onSearch = (searchBy, query) =>
    dispatch => {

        if (mapClaimValidation(searchBy, query)) {

            dispatch(routerActions.push(mapSearchRoutes(searchBy, query)));

        } else {

            const translatedErrorMessage = translate(mapValidationErrorMessages(searchBy));

            errorAlertBar(createErrorObject(translatedErrorMessage));

        }

    };



// WEBPACK FOOTER //
// ./src/home-page/action-creators/search.js